import {
  TextField as MUITextField
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";

const TextField = React.memo(MUITextField);

export default function PassportSection({ formik, disabled = false }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);


  return (
    <>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Passport number</InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.passportNumber"
                value={formik.values.personal.passportNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.passportNumber", formik)}
                helperText={getErrorMessage("personal.passportNumber", formik)}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Issued at</InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.issuedAt"
                value={formik.values.personal.issuedAt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.issuedAt", formik)}
                helperText={getErrorMessage("personal.issuedAt", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Date of issue (dd-mm-yyyy)</InputLabel>
              <DatePicker
                disabled={disabled || !canEdit}
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Date of issue"
                views={["year", "month", "date"]}
                name={`personal.dateofIssue`}
                value={get(formik.values, `personal.dateofIssue`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(
                    `personal.dateofIssue`,
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(`personal.dateofIssue`, formik)}
                helperText={getErrorMessage(`personal.dateofIssue`, formik)}
              />
            </div>
          </div>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
              <DatePicker
                disabled={disabled || !canEdit}
                className={classes.formControl}
                // style={{ width: 200 }}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Valid until"
                views={["year", "month", "date"]}
                name={`personal.validuntil`}
                value={get(formik.values, `personal.validuntil`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(
                    `personal.validuntil`,
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(`personal.validuntil`, formik)}
                helperText={getErrorMessage(`personal.validuntil`, formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

    </>
  );
}
